var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M9 6v3a3 3 0 0 0 6 0V6H9zM8 6h8v3a4 4 0 1 1-8 0V6zM5 21h14v-3a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v3zm3-7h8a4 4 0 0 1 4 4v4H4v-4a4 4 0 0 1 4-4zm1-9h6V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1zm1-3h4a2 2 0 0 1 2 2v2H8V4a2 2 0 0 1 2-2zM9 15h1v6H9v-6zm2 1h2v1h-2v-1zm0 2h2v1h-2v-1z" })
  );
});